module.exports = __webpack_public_path__ + "static/media/logo.2a783879.png";